<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

<!-- 編集フォーム -->
@if (!showSpinner) {
  <div class="edit-container">

    <!-- 左サイドメニュー -->
    <div class="side-menu">
      <button mat-raised-button class="save-btn" [disabled]="isSaving || isAgeRatioOver100" (click)="onSave()">
        @if (isSaving) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          保存
        }
      </button>
      <button mat-raised-button class="cancel-btn" (click)="onCancel()">戻る</button>
    </div>

    <!-- メインエリア -->
    <div class="main-area">

      <!-- ヘッダー -->
      <div class="edit-header">
        <h2 class="edit-title">報告書 編集</h2>
        <span class="status-badge" [class]="'status-' + form.status">{{ statusLabel }}</span>
      </div>

      <!-- フォームテーブル -->
      <div class="form-table">

        <!-- ===== タイトル ===== -->
        <div class="form-row one-row">
          <div class="form-label">タイトル <span class="required"></span></div>
          <div class="form-field">
            <span class="readonly-text title">{{ form.title }}</span>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- ===== カテゴリー ===== -->
        <div class="form-row">
          <div class="form-label">カテゴリー <span class="required"></span>@if (form.categoryId === 8 || form.categoryId === 9) {<span class="private-notice category-label">このカテゴリーは他組織へ非公開です。</span>}</div>
          <div class="form-field">
            <div class="category-row large">
              <span class="sub-label">大分類</span>
              <span class="category-major-text">{{ form.categoryMajorName }}</span>
              @if (form.categoryId === 8 || form.categoryId === 9) {
                <span class="private-notice category">このカテゴリーは他組織へ非公開です。</span>
              }
            </div>
            @if (form.categorySub.length > 0) {
              <div class="category-row">
                <span class="sub-label">中分類</span>
                <!-- 1行に入りきらず折り返すときは、1〜3を縦に並べる -->
                <div #categorySubGrid class="checkbox-grid inline" [class.stack]="shouldStackPriority(categorySubGrid, form.categorySub)">
                  @for (sub of form.categorySub; track $index; let i = $index) {
                    <label class="priority-checkbox fixed">
                      <span class="priority-num">{{ i + 1 }}</span> {{ sub }}
                    </label>
                  }
                </div>
              </div>
            }
          </div>
          <div class="form-action"></div>
        </div>

        <!-- ===== 実施状況 ===== -->
        <div class="form-row one-row">
          <div class="form-label">実施状況 <span class="required">※</span></div>
          <div class="form-field">
            <div class="radio-row">
              @for (item of implementationStatusOptions; track item.id) {
                <label class="radio-label">
                  <input type="radio" name="implementationStatus"
                         [(ngModel)]="form.implementationStatus"
                         [value]="item.id">
                  {{ item.name }}
                </label>
              }
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- ===== 実施方法（限定表示時は非表示）===== -->
        @if (!isLimitedDisplay) {
          <div class="form-row one-row">
            <div class="form-label">実施方法 <span class="required">※</span></div>
            <div class="form-field">
              <div class="radio-row">
                @for (item of implementationMethodOptions; track item.id) {
                  <label class="radio-label">
                    <input type="radio" name="implementationMethod"
                           [(ngModel)]="form.implementationMethod"
                           [value]="item.id">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 問題の有無（カテゴリー8 / 延期・中止）===== -->
        @if (showProblem) {
          <div class="form-row one-row">
            <div class="form-label">問題の有無 <span class="required">※</span></div>
            <div class="form-field">
              <div class="radio-row">
                <label class="radio-label">
                  <input type="radio" name="hasProblem" [(ngModel)]="form.hasProblem" [value]="true"> あり
                </label>
                <label class="radio-label">
                  <input type="radio" name="hasProblem" [(ngModel)]="form.hasProblem" [value]="false"> なし
                </label>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
          <div class="form-row top sub-row">
            <div class="form-label text">└ コメント <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.problemComment.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.problemComment" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 関係者情報（カテゴリー5, 7 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showStakeholderAndChallenges) {
          <div class="form-row">
            <div class="form-label text">関係者情報 <span class="required">※</span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <div class="field-with-count half">
                  <span class="char-count">{{ form.stakeholderInfo.length }} / 30</span>
                  <input type="text" class="text-input" [(ngModel)]="form.stakeholderInfo" maxlength="30"
                         placeholder="対応者氏名など">
                </div>
                <span class="private-notice margintop">この項目は他組織へ非公開です。</span>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 企画書からの変更点（全カテゴリー）===== -->
        <div class="form-row one-row">
          <div class="form-label">企画書からの変更点 <span class="required">※</span></div>
          <div class="form-field">
            <div class="radio-row">
              <label class="radio-label">
                <input type="radio" name="hasChangeFromPlan" [(ngModel)]="form.hasChangeFromPlan" [value]="true"> あり
              </label>
              <label class="radio-label">
                <input type="radio" name="hasChangeFromPlan" [(ngModel)]="form.hasChangeFromPlan" [value]="false"> なし
              </label>
            </div>
          </div>
          <div class="form-action"></div>
        </div>
        <div class="form-row top sub-row">
          <div class="form-label text">└ コメント <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.changeFromPlanComment.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.changeFromPlanComment" maxlength="300" rows="4"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- ===== 実費費用（カテゴリー1,2,3,9,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showCost) {
          <div class="form-row one-row">
            <div class="form-label">実費費用総額 <span class="required">@if (form.categoryId !== 10) {※}</span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <input type="text" inputmode="numeric" class="number-input cost" [(ngModel)]="form.actualTotalCost"
                       maxlength="10" placeholder="半角数字"
                       (input)="onNumberInput($event, 'actualTotalCost', 10)">
                <span class="unit">円</span>
                @if (costDiff) {
                  <span class="calc-result"><span class="calc-label">想定との差額</span>{{ costDiff }}</span>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
          <div class="form-row top">
            <div class="form-label text">差額発生理由など <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.costDiffReason.length }} / 300</span>
                <textarea class="textarea-input half-height" [(ngModel)]="form.costDiffReason" maxlength="300" rows="2"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 参加者（カテゴリー1,2,3,5,6,9,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showTotalParticipants) {
          <div class="form-row one-row">
            <div class="form-label">参加者 <span class="required">※</span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <span class="sub-label first-inline">総数</span>
                <input type="text" inputmode="numeric" class="number-input short" [(ngModel)]="form.participantTotal"
                       maxlength="5" placeholder="半角数字"
                       (input)="onNumberInput($event, 'participantTotal', 5)">
                <span class="unit">人</span>
                @if (showParticipantDetail) {
                  <span class="sub-label ml20">新規</span>
                  <input type="text" inputmode="numeric" class="number-input short" [(ngModel)]="form.participantNew"
                         maxlength="5" placeholder="半角数字"
                         (input)="onNumberInput($event, 'participantNew', 5)">
                  <span class="unit">人</span>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 年代（カテゴリー1,2,3,10） -->
          @if (showParticipantDetail) {
            <div class="form-row">
              <div class="form-label age">年代 <span class="required"></span></div>
              <div class="form-field">
                <div class="age-grid">
                  <div class="age-row">
                    <span class="age-item">
                      <span class="age-label">19歳以下</span>
                      <mat-form-field appearance="fill" class="no-line age-select">
                        <mat-select [(ngModel)]="form.ageRatio.under19" [disabled]="form.ageRatio.unknown" panelClass="age-select-panel">
                          @for (opt of agePercentOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="unit">%</span>
                    </span>

                    <span class="age-item">
                      <span class="age-label">20代</span>
                      <mat-form-field appearance="fill" class="no-line age-select">
                        <mat-select [(ngModel)]="form.ageRatio.age20s" [disabled]="form.ageRatio.unknown" panelClass="age-select-panel">
                          @for (opt of agePercentOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="unit">%</span>
                    </span>

                    <span class="age-item">
                      <span class="age-label">30代</span>
                      <mat-form-field appearance="fill" class="no-line age-select">
                        <mat-select [(ngModel)]="form.ageRatio.age30s" [disabled]="form.ageRatio.unknown" panelClass="age-select-panel">
                          @for (opt of agePercentOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="unit">%</span>
                    </span>

                    <span class="age-item">
                      <span class="age-label">40代</span>
                      <mat-form-field appearance="fill" class="no-line age-select">
                        <mat-select [(ngModel)]="form.ageRatio.age40s" [disabled]="form.ageRatio.unknown" panelClass="age-select-panel">
                          @for (opt of agePercentOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="unit">%</span>
                    </span>
                  </div>
                  <div class="age-row">
                    <span class="age-item">
                      <span class="age-label">50代</span>
                      <mat-form-field appearance="fill" class="no-line age-select">
                        <mat-select [(ngModel)]="form.ageRatio.age50s" [disabled]="form.ageRatio.unknown" panelClass="age-select-panel">
                          @for (opt of agePercentOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="unit">%</span>
                    </span>

                    <span class="age-item">
                      <span class="age-label">60代以上</span>
                      <mat-form-field appearance="fill" class="no-line age-select">
                        <mat-select [(ngModel)]="form.ageRatio.over60" [disabled]="form.ageRatio.unknown" panelClass="age-select-panel">
                          @for (opt of agePercentOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="unit">%</span>
                    </span>

                    <span class="age-total" [class.over]="isAgeRatioOver100">合計 {{ ageRatioTotal }} %</span>
                  </div>
                </div>
                <div class="unknown-check-row">
                  <label class="checkbox-label">
                    不明の場合はこちらにチェック
                    <input type="checkbox" [(ngModel)]="form.ageRatio.unknown" (change)="onAgeUnknownChange()">
                  </label>
                </div>
              </div>
              <div class="form-action"></div>
            </div>

            <!-- 女性比率 -->
            <div class="form-row one-row">
              <div class="form-label">女性比率 <span class="required">※</span></div>
              <div class="form-field">
                <mat-form-field appearance="fill" class="no-line">
                  <mat-select [(ngModel)]="form.femaleRatio" [panelWidth]="getMasterItems('report_female_ratio') | optionPanelWidth : 150">
                    @for (item of getMasterItems('report_female_ratio'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-action"></div>
            </div>
          }
        }

        <!-- ===== 実施内容（カテゴリー6のみ / 限定表示外）===== -->
        @if (!isLimitedDisplay && showOrgActivity) {
          <div class="form-row">
            <div class="form-label text">実施内容 <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.implementationContent.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.implementationContent" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 改善したい指標（企画の成果）+ 実施結果/成果（カテゴリー1,2,3,5,6,7,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showOutcomeResult) {
          <div class="form-row one-row">
            <div class="form-label">改善したい指標 <span class="required"></span></div>
            <div class="form-field">
              <div class="category-row">
                <span class="sub-label">企画の成果</span>
                <div class="checkbox-grid inline">
                  @if (form.improvementOutcomeText) {
                    <label class="priority-checkbox fixed">{{ form.improvementOutcomeText }}</label>
                  }
                </div>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <div class="form-row top">
            <div class="form-label text">実施結果/成果 <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.implementationResult.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.implementationResult" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 課題/気づき（カテゴリー5, 7 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showStakeholderAndChallenges) {
          <div class="form-row">
            <div class="form-label text">課題/気づき <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.challengesNotes.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.challengesNotes" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 次回改善点/引継事項（カテゴリー1,2,3,5,6,7,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showNextImprovement) {
          <div class="form-row">
            <div class="form-label text"><span class="label-pc">次回改善点<br>引継事項</span><span class="label-sp">次回改善点/引継事項</span> <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.nextImprovement.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.nextImprovement" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 労使交渉セクション（カテゴリー8 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showLaborNegotiation) {
          <!-- 協議状況 -->
          <div class="form-row one-row">
            <div class="form-label">協議状況 <span class="required">※</span></div>
            <div class="form-field">
              <div class="radio-row">
                @for (item of negotiationStatusOptions; track item.id) {
                  <label class="radio-label">
                    <input type="radio" name="negotiationStatus"
                           [(ngModel)]="form.negotiationStatus"
                           [value]="item.id"
                           (ngModelChange)="onNegotiationStatusChange()">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 合意内容（合意・一部合意時） -->
          @if (showAgreementContent) {
            <div class="form-row">
              <div class="form-label text">合意内容 <span class="required">※</span></div>
              <div class="form-field">
                <div class="field-with-count">
                  <span class="char-count">{{ form.agreementContent.length }} / 300</span>
                  <textarea class="textarea-input" [(ngModel)]="form.agreementContent" maxlength="300" rows="4"></textarea>
                </div>
              </div>
              <div class="form-action"></div>
            </div>
          }

          <!-- 会社側主張/論理 -->
          <div class="form-row">
            <div class="form-label text"><span class="label-pc">会社側<br>主張/論理</span><span class="label-sp">会社側主張/論理</span> <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.companyClaim.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.companyClaim" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 労組側主張/論理 -->
          <div class="form-row">
            <div class="form-label text"><span class="label-pc">労組側<br>主張/論理</span><span class="label-sp">労組側主張/論理</span> <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.unionClaim.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.unionClaim" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 未整理論点/積み残し -->
          <div class="form-row">
            <div class="form-label text"><span class="label-pc">未整理論点<br>積み残し</span><span class="label-sp">未整理論点/積み残し</span> <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.unresolvedPoints.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.unresolvedPoints" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 改善したい指標（状態の変化）+ 改善指標結果（カテゴリー1,2,3,5,6,7,8,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showImprovementResult) {
          <div class="form-row one-row">
            <div class="form-label">改善したい指標 <span class="required"></span></div>
            <div class="form-field">
              <div class="category-row">
                <span class="sub-label">状態の変化</span>
                <!-- 1行に入りきらず折り返すときは、1〜3を縦に並べる -->
                <div #improvementStateGrid class="checkbox-grid inline" [class.stack]="shouldStackPriority(improvementStateGrid, form.improvementStateItems)">
                  @for (item of form.improvementStateItems; track $index; let i = $index) {
                    <label class="priority-checkbox fixed">
                      <span class="priority-num">{{ i + 1 }}</span> {{ item }}
                    </label>
                  }
                </div>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <div class="form-row one-row">
            <div class="form-label">改善指標に対する結果 <span class="required">※</span></div>
            <div class="form-field">
              <mat-form-field appearance="fill" class="no-line wide">
                <mat-select [(ngModel)]="form.improvementResultRating" [panelWidth]="getMasterItems('report_improvement_result') | optionPanelWidth : 232">
                  @for (item of getMasterItems('report_improvement_result'); track item.id) {
                    <mat-option [value]="item.id">{{ item.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-action"></div>
          </div>

          <div class="form-row top">
            <div class="form-label text">判断理由/補足 <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.improvementResultReason.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.improvementResultReason" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 評価セクション（カテゴリー1,2,3,6,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showEvaluation) {
          <!-- 再参加意向比率 -->
          <div class="form-row one-row">
            <div class="form-label">再参加意向比率 <span class="required"></span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <input type="text" inputmode="numeric" class="number-input mini" [(ngModel)]="form.reAttendanceRate"
                       maxlength="3" placeholder="半角数字"
                       (input)="onNumberInput($event, 'reAttendanceRate', 3)">
                <span class="unit">%</span>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 参加者 評価 -->
          <div class="form-row">
            <div class="form-label age">参加者 評価 <span class="required">※</span></div>
            <div class="form-field">
              <div class="inline-selects">
                <span class="sub-label first">点数</span>
                <mat-form-field appearance="fill" class="no-line">
                  <mat-select [(ngModel)]="form.participantEvalScore" [panelWidth]="getMasterItems('report_eval_score') | optionPanelWidth : 150">
                    @for (item of getMasterItems('report_eval_score'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (!isEvaluationUnrated) {
                  <span class="eval-collect">
                    <span class="sub-label ml20">評価収集数</span>
                    <input type="text" inputmode="numeric" class="number-input short" [(ngModel)]="form.evalCollectedCount"
                           maxlength="5" placeholder="半角数字"
                           (input)="onNumberInput($event, 'evalCollectedCount', 5)">
                    @if (c !== 6) {
                      <span class="sub-label ml20">収集率　{{ collectionRate }}</span>
                    }
                  </span>
                }
              </div>
              @if (isEvaluationUnrated) {
              <div class="unevaluatedReason-text">
                <span class="sub-label first">未評価理由</span>
                <div class="field-with-count">
                  <span class="char-count">{{ form.unevaluatedReason.length }} / 300</span>
                  <textarea class="textarea-input half-height" [(ngModel)]="form.unevaluatedReason" maxlength="300" rows="2"></textarea>
                </div>

              </div>
              }
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 評価内訳（カテゴリー1,2,3,10） -->
          @if (showParticipantDetail) {
            <div class="form-row">
              <div class="form-label">評価 内訳 <span class="required"></span></div>
              <div class="form-field">
                <!-- イベント：1部 -->
                <div class="eval-breakdown-block">
                  <span class="breakdown-part-label">イベント：1部</span>
                  <div class="breakdown-row first">
                    <span class="sub-label input">タイトル</span>
                    <div class="field-with-count breakdown-title-field">
                      <span class="char-count">{{ form.evaluationPart1.title.length }} / 50</span>
                      <input type="text" class="text-input" [(ngModel)]="form.evaluationPart1.title" maxlength="50">
                    </div>
                  </div>
                  <div class="breakdown-row">
                    <span class="sub-label">点数</span>
                    <mat-form-field appearance="fill" class="no-line">
                      <mat-select [(ngModel)]="form.evaluationPart1.score" [panelWidth]="getMasterItems('report_event_score') | optionPanelWidth : 150">
                        <mat-option [value]="null"></mat-option>
                        @for (item of getMasterItems('report_event_score'); track item.id) {
                          <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <!-- イベント：2部 -->
                <div class="eval-breakdown-block">
                  <span class="breakdown-part-label">イベント：2部</span>
                  <div class="breakdown-row first">
                    <span class="sub-label input">タイトル</span>
                    <div class="field-with-count breakdown-title-field">
                      <span class="char-count">{{ form.evaluationPart2.title.length }} / 50</span>
                      <input type="text" class="text-input" [(ngModel)]="form.evaluationPart2.title" maxlength="50">
                    </div>
                  </div>
                  <div class="breakdown-row">
                    <span class="sub-label">点数</span>
                    <mat-form-field appearance="fill" class="no-line">
                      <mat-select [(ngModel)]="form.evaluationPart2.score" [panelWidth]="getMasterItems('report_event_score') | optionPanelWidth : 150">
                        <mat-option [value]="null"></mat-option>
                        @for (item of getMasterItems('report_event_score'); track item.id) {
                          <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="form-action"></div>
            </div>
          }
        }

        <!-- ===== 参加者理解度（カテゴリー2のみ / 限定表示外）===== -->
        @if (!isLimitedDisplay && showUnderstanding) {
          <div class="form-row one-row">
            <div class="form-label">参加者 理解度 <span class="required"></span></div>
            <div class="form-field">
              <div class="inline-selects">
                <span class="sub-label first">点数</span>
                <mat-form-field appearance="fill" class="no-line wide">
                  <mat-select [(ngModel)]="form.understandingScore" [panelWidth]="getMasterItems('report_understanding_score') | optionPanelWidth : 232">
                    @for (item of getMasterItems('report_understanding_score'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 参加者による意見/感想（カテゴリー1,2,3,6,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showEvaluation) {
          <div class="form-row">
            <div class="form-label text"><span class="label-pc">参加者による<br>意見/感想など</span><span class="label-sp">参加者による意見/感想など</span> <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.participantOpinions.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.participantOpinions" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 評価データ -->
          <div class="form-row">
            <div class="form-label upload">評価データ <span class="required"></span></div>
            <div class="form-field">
              <input type="file" #fileInputEval hidden
                     accept=".pdf,.jpg,.jpeg,.png,.ppt,.pptx,.xls,.xlsx,.doc,.docx"
                     (change)="onFileSelected($event, 'eval')">
              <div class="upload-note-row">
                <span class="file-note"><span class="file-note-mark">※</span> <span>3点まで、各10M以内、拡張子：pdf、jpg、png、ppt、pptx、xls、xlsx、doc、docx</span></span>
              </div>
              <div class="upload-btn-area">
                <div class="upload-btn-wrap">
                  <button class="upload-btn" (click)="onFileUpload('eval')"
                            [disabled]="(attachments.eval.length >= 3) || uploadingCategory === 'eval'">アップロード</button>
                  <!-- アップロード中はボタンの右にスピナーを出す（ボタンは消さずに押せない状態にする。スピナーの場所は常に確保） -->
                  <div class="upload-spinner-slot">
                    @if (uploadingCategory === 'eval') {
                      <mat-spinner diameter="20"></mat-spinner>
                    }
                  </div>
                </div>
                <span class="private-notice">ファイルは他組織へ非公開です。</span>
              </div>
              @if (attachments.eval.length > 0) {
                <div class="attachment-list">
                  @for (att of attachments.eval; track $index; let i = $index) {
                    <div class="attachment-item">
                      <span class="attachment-name" [class.attachment-link]="att.downloadUrl"
                            (click)="onDownloadAttachment(att)">{{ att.fileName }}</span>
                      <button class="remove-btn" (click)="removeAttachment('eval', i)">
                        <i class="material-icons">close</i>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 自己評価/採点 -->
          <div class="form-row one-row">
            <div class="form-label">自己評価/採点 <span class="required"></span></div>
            <div class="form-field">
              <div class="inline-selects">
                <span class="sub-label first">点数</span>
                <mat-form-field appearance="fill" class="no-line">
                  <mat-select [(ngModel)]="form.selfEvalScore" [panelWidth]="getMasterItems('report_self_eval_score') | optionPanelWidth : 150">
                    <mat-option [value]="null"></mat-option>
                    @for (item of getMasterItems('report_self_eval_score'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
          <div class="form-row top sub-row">
            <div class="form-label text">└ コメント <span class="required"></span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.selfEvalComment.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.selfEvalComment" maxlength="300" rows="4"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 再実施の可否 -->
          <div class="form-row one-row">
            <div class="form-label">再実施の可否 <span class="required"></span></div>
            <div class="form-field">
              <mat-form-field appearance="fill" class="no-line redo-select">
                <mat-select [(ngModel)]="form.canRedo" [panelWidth]="getMasterItems('report_can_redo') | optionPanelWidth : 206">
                  <mat-option [value]="null"></mat-option>
                  @for (item of getMasterItems('report_can_redo'); track item.id) {
                    <mat-option [value]="item.id">{{ item.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 画像（カテゴリー1,2,3,5,6,7,9,10 / 限定表示外）===== -->
        @if (!isLimitedDisplay && showImages) {
          <div class="form-row">
            <div class="form-label upload">画像 <span class="required"></span></div>
            <div class="form-field">
              <input type="file" #fileInputImage hidden
                     accept=".jpg,.jpeg,.png"
                     (change)="onFileSelected($event, 'image')">
              <div class="upload-note-row">
                <span class="file-note"><span class="file-note-mark">※</span> <span>3点まで、各5M以内、拡張子：jpg、png</span></span>
              </div>
              <div class="upload-btn-area">
                <div class="upload-btn-wrap">
                  <button class="upload-btn" (click)="onFileUpload('image')"
                            [disabled]="(attachments.image.length >= 3) || uploadingCategory === 'image'">アップロード</button>
                  <!-- アップロード中はボタンの右にスピナーを出す（ボタンは消さずに押せない状態にする。スピナーの場所は常に確保） -->
                  <div class="upload-spinner-slot">
                    @if (uploadingCategory === 'image') {
                      <mat-spinner diameter="20"></mat-spinner>
                    }
                  </div>
                </div>
                <span class="private-notice">画像は他組織へ非公開です。</span>
              </div>
              @if (attachments.image.length > 0) {
                <div class="image-preview-grid">
                  @for (att of attachments.image; track $index; let i = $index) {
                    <div class="image-preview-item">
                      @if (att.downloadUrl) {
                        <img [src]="att.downloadUrl" [alt]="att.fileName" class="image-preview-img"
                             (click)="openLightbox(att.downloadUrl)">
                      } @else {
                        <div class="image-preview-placeholder">{{ att.fileName }}</div>
                      }
                      <button class="image-remove-btn" (click)="removeAttachment('image', i)">×</button>
                    </div>
                  }
                </div>
              }

              <!-- ライトボックス -->
              @if (lightboxUrl) {
                <div class="lightbox-overlay" (click)="closeLightbox()">
                  <img [src]="lightboxUrl" class="lightbox-img" (click)="$event.stopPropagation()">
                </div>
              }
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 成果物データ（全カテゴリー / 限定表示外）===== -->
        @if (!isLimitedDisplay) {
          <div class="form-row">
            <div class="form-label upload">成果物データ <span class="required"></span></div>
            <div class="form-field">
              <input type="file" #fileInputDeliverable hidden
                     accept=".pdf,.jpg,.jpeg,.png,.ppt,.pptx,.xls,.xlsx,.doc,.docx"
                     (change)="onFileSelected($event, 'deliverable')">
              <div class="upload-note-row">
                <span class="file-note"><span class="file-note-mark">※</span> <span>3点まで、各10M以内、拡張子：pdf、jpg、png、ppt、pptx、xls、xlsx、doc、docx</span></span>
              </div>
              <div class="upload-btn-area">
                <div class="upload-btn-wrap">
                  <button class="upload-btn" (click)="onFileUpload('deliverable')"
                            [disabled]="(attachments.deliverable.length >= 3) || uploadingCategory === 'deliverable'">アップロード</button>
                  <!-- アップロード中はボタンの右にスピナーを出す（ボタンは消さずに押せない状態にする。スピナーの場所は常に確保） -->
                  <div class="upload-spinner-slot">
                    @if (uploadingCategory === 'deliverable') {
                      <mat-spinner diameter="20"></mat-spinner>
                    }
                  </div>
                </div>
                <span class="private-notice">ファイルは他組織へ非公開です。</span>
              </div>
              @if (attachments.deliverable.length > 0) {
                <div class="attachment-list">
                  @for (att of attachments.deliverable; track $index; let i = $index) {
                    <div class="attachment-item">
                      <span class="attachment-name" [class.attachment-link]="att.downloadUrl"
                            (click)="onDownloadAttachment(att)">{{ att.fileName }}</span>
                      <button class="remove-btn" (click)="removeAttachment('deliverable', i)">
                        <i class="material-icons">close</i>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 報告書資料 -->
          <div class="form-row">
            <div class="form-label upload">報告書資料 <span class="required"></span></div>
            <div class="form-field">
              <input type="file" #fileInputReportDoc hidden
                     accept=".pdf,.jpg,.jpeg,.png,.ppt,.pptx,.xls,.xlsx,.doc,.docx"
                     (change)="onFileSelected($event, 'reportDoc')">
              <div class="upload-note-row">
                <span class="file-note"><span class="file-note-mark">※</span> <span>3点まで、各10M以内、拡張子：pdf、jpg、png、ppt、pptx、xls、xlsx、doc、docx</span></span>
              </div>
              <div class="upload-btn-area">
                <div class="upload-btn-wrap">
                  <button class="upload-btn" (click)="onFileUpload('reportDoc')"
                            [disabled]="(attachments.reportDoc.length >= 3) || uploadingCategory === 'reportDoc'">アップロード</button>
                  <!-- アップロード中はボタンの右にスピナーを出す（ボタンは消さずに押せない状態にする。スピナーの場所は常に確保） -->
                  <div class="upload-spinner-slot">
                    @if (uploadingCategory === 'reportDoc') {
                      <mat-spinner diameter="20"></mat-spinner>
                    }
                  </div>
                </div>
                <span class="private-notice">ファイルは他組織へ非公開です。</span>
              </div>
              @if (attachments.reportDoc.length > 0) {
                <div class="attachment-list">
                  @for (att of attachments.reportDoc; track $index; let i = $index) {
                    <div class="attachment-item">
                      <span class="attachment-name" [class.attachment-link]="att.downloadUrl"
                            (click)="onDownloadAttachment(att)">{{ att.fileName }}</span>
                      <button class="remove-btn" (click)="removeAttachment('reportDoc', i)">
                        <i class="material-icons">close</i>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ===== 組合員向け報告方法（全カテゴリー / 限定表示外）===== -->
        @if (!isLimitedDisplay) {
          <div class="form-row">
            <div class="form-label">組合員向け報告方法 <span class="required">※</span></div>
            <div class="form-field">
              <span class="file-note top-note">※ 優先度の高い順に最大3つまで選択</span>
              <div [class]="'checkbox-grid short-items cols-5 sp-eq-' + unionMethodSpCols">
                @for (item of getMasterItems('report_union_method'); track item.id) {
                  <label class="priority-checkbox"
                    [class.checked]="isInPriority(form.unionReportMethod, item.id)"
                    [class.disabled]="isPriorityDisabled(form.unionReportMethod, item.id, 3)"
                    (click)="togglePriority(form.unionReportMethod, item.id, 3); $event.preventDefault()">
                    @if (getPriorityNum(form.unionReportMethod, item.id); as num) {
                      <span class="priority-num">{{ num }}</span>
                    } @else {
                      <input type="checkbox" class="priority-checkbox-native" [checked]="false"
                             tabindex="-1"
                             [disabled]="isPriorityDisabled(form.unionReportMethod, item.id, 3)">
                    }
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.unionReportMethod)">× リセット</button>
            </div>
          </div>
        }

        <!-- ===== メモ（全カテゴリー）===== -->
        <div class="form-row">
          <div class="label-row">
            <div class="form-label memo">メモ <span class="required"></span></div>
            <span class="private-notice memo">他組織へ非公開</span>
          </div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.memo.length }} / 10000</span>
              <textarea class="textarea-input memo-textarea" [(ngModel)]="form.memo" maxlength="10000" rows="6"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

      </div><!-- /form-table -->
    </div><!-- /main-area -->
  </div><!-- /edit-container -->
}
